"use strict";

var _preact = require("preact");
module.exports = function (_ref) {
  var i18n = _ref.i18n,
    logout = _ref.logout,
    username = _ref.username;
  return [(0, _preact.h)("span", {
    className: "uppy-ProviderBrowser-user",
    key: "username"
  }, username), (0, _preact.h)("button", {
    type: "button",
    onClick: logout,
    className: "uppy-u-reset uppy-ProviderBrowser-userLogout",
    key: "logout"
  }, i18n('logOut'))];
};